import React from 'react';
import { AnalyticsSenderProvider } from '@funtech-int/yango-shared';

import { PlayerManager } from '@/scenarios/legacy-player/components/PlayerManager/PlayerManagerMain';
import { clientOnlyPage } from '@/shared/lib/clientOnly';

import { SportShowcase } from '../Showcase/Showcase';

export enum SportShowcaseId {
    MAIN = 'main',
}

const SportMainComponent = () => (
    <main>
        <SportShowcase id={SportShowcaseId.MAIN} />
    </main>
);

const MainScreen = clientOnlyPage(() => (
    <>
        <PlayerManager />
        <AnalyticsSenderProvider>
            <SportMainComponent />
        </AnalyticsSenderProvider>
    </>
));

export default MainScreen;
